<template>
  <div class="meterial-input-page" >
    <a-row :gutter="13">
      <a-col :xl="leftColWidth"  :span="24"  >
        <workshop-group-list   @chooseGroup="handleChooseGroup" ></workshop-group-list>
      </a-col>
      <a-col :xl="rightColWidth" :span="24" v-show="choosedGroupId"  >
        <workshop-group-detail   ref="WorkshopGroupDetail" @close="handleCloseDetail" ></workshop-group-detail>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import WorkshopGroupList from '@/views/gisFactoryInspection/components/WorkshopGroupList.vue'
import WorkshopGroupDetail from '@/views/gisFactoryInspection/components/WorkshopGroupDetail.vue'

export default {
  data() {
    return {
      choosedGroupId:""
    }
  },
  methods: {
    handleChooseGroup(record){
      this.choosedGroupId=record.id
      let recordCopy=JSON.parse(JSON.stringify(record))
      recordCopy.groupId=recordCopy.id;
      delete recordCopy.id;
      this.$nextTick(()=>{
        this.$refs.WorkshopGroupDetail.choosedGroup(recordCopy);
      })
    },
    handleCloseDetail(){
      this.choosedGroupId=''
    }
  },
  computed:{
    leftColWidth(){
      return this.choosedGroupId?12:24
    },
    rightColWidth(){
      return this.choosedGroupId?12:0
    }
  },
  components:{
    WorkshopGroupList,WorkshopGroupDetail
  }
}
</script>

<style lang="less" scoped>
.meterial-input-page{
  height: 100%;
}
</style>